import { render } from "./CommentItem.vue?vue&type=template&id=5b870d22&scoped=true"
import script from "./CommentItem.vue?vue&type=script&lang=js"
export * from "./CommentItem.vue?vue&type=script&lang=js"

import "./CommentItem.vue?vue&type=style&index=0&id=5b870d22&lang=scss&scoped=true"
import "./CommentItem.vue?vue&type=style&index=1&id=5b870d22&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b870d22"]])

export default __exports__